// @core/api/endpoints/context/list_manifests.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListManifestsResponse,
} from '../../../types/context';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/context';

/**
 * List all registered manifests
 * Returns all aspect and relation group manifests registered in the system. Used by admin UI to display available sections and their default configurations.
 */
export async function ListManifests(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListManifestsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/context/manifests`;
  const requestOptions = options;
  return client.get<ListManifestsResponse>(requestPath, { ...requestOptions, params });
}
